export default __webpack_public_path__ + "static/media/kitchen-2165756_640.802ae629.jpg";